import React from 'react';
import AdminDynamicTable from '../components/common/Tables/AdminDynamicTable';


export const Issuers = ({
  client
 }) => {
    return (
        <div className="issuers">
            <AdminDynamicTable
                client={client}
                url="issuers"
                title="Issuers"
                excludeHeaderFields={['id']}
                excludeEditFields={['id']}
                readOnly={[]}
            />
        </div>
    );
};

export default Issuers;


// WEBPACK FOOTER //
// ./src/pages/Issuers.jsx